import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    blockTitle: React.CSSProperties;
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    blockTitle?: React.CSSProperties;
  }
}

const theme = createTheme({
  typography: {
    caption: {
      fontWeight: 'bold',
    },
  },
  palette: {
    primary: {
      main: '#008080',
      dark: '#005353',
      light: '#66cccc',
      contrastText: '#fff',
    },
    secondary: {
      main: '#ff5722',
      dark: '#c41c00',
      light: '#ff8a50',
      contrastText: '#fff',
    },
    error: {
      main: '#f44336',
      dark: '#b71c1c',
      light: '#e57373',
      contrastText: '#fff',
    },
    warning: {
      // Warning color options
      main: '#ff9800',
      dark: '#f57c00',
      light: '#ffb74d',
      contrastText: '#fff',
    },
    info: {
      // Info color options
      main: '#2196f3',
      dark: '#1565c0',
      light: '#64b5f6',
      contrastText: '#fff',
    },
    success: {
      // Success color options
      main: '#4caf50',
      dark: '#388e3c',
      light: '#81c784',
      contrastText: '#fff',
    },
    common: {
      // Common color options
      black: '#000',
      white: '#fff',
    },
    text: {
      // Text color options
      primary: '#000',
      secondary: '#666',
      disabled: '#999',
    },
  },
});
export default theme;
